import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type Secret } from '../../api/security';

export function SecretsVaultPage() {
  const [secrets, setSecrets] = useState<Secret[]>([]);
  const [result, setResult] = useState<string | null>(null);
  useEffect(() => { void securityApi.secrets().then(setSecrets); }, []);
  const rotate = async (id: string) => {
    const r = await securityApi.rotateKey({ secret_id: id, initiated_by: 'admin' });
    setResult(`Rotation ${r.status}`);
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Secrets Vault</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      {result && <p className="mt-4 text-sm text-indigo-700 dark:text-indigo-400">{result}</p>}
      <div className="mt-6 space-y-3">{secrets.map((s) => (
        <div key={s.id} className="flex items-center justify-between rounded-xl border p-4 dark:border-slate-700">
          <div><p className="font-medium">{s.name}</p><p className="text-sm text-slate-500">{s.type} · {s.status}</p></div>
          <button type="button" onClick={() => rotate(s.id)} className="text-sm text-indigo-700 hover:underline dark:text-indigo-400">Rotate</button>
        </div>
      ))}</div>
    </div>
  );
}
